export default __webpack_public_path__ + "static/media/chillrx-stack2.webp";